import { RouteObject } from 'react-router-dom';
import { FeatureCreateJob } from './feature-create-job';
import { FeatureCopyJob } from './feature-copy-job';
import { SimpleCV } from './feature-simple-cv/QuestionnaireView';
import { CandidateAppliedView } from './feature-candidate-applied-view';
import { FeatureJobApplicants} from './feature-job-applicants';

export const EMPLOYER_ROUTES: RouteObject[] = [
   {
      path: '/user/createjob',
      Component: FeatureCreateJob,
   },
   {
      path: '/user/copy-job/:slug',
      Component: FeatureCopyJob,
   },
   {
      path: '/candidates/simple-cv/:id',
      Component: SimpleCV,
   },
   {
      path: '/user/managejob/accdetail/:slug',
      Component: FeatureJobApplicants
   },
    {
      path: '/candidates/job-applied-view/:id',
      Component: CandidateAppliedView,
   },
];
